// Shared band-strategy definitions for the Bollinger chart's backtest picker
// and the notifications UI, so the key→label mapping lives in exactly one place.
export const STRATEGIES = [
  { key: 'band', label: 'band → band', hint: 'Buy in the lower-band zone, sell in the upper-band zone. Captures full swings.' },
  { key: 'meanLong', label: 'band → mean', hint: 'Buy in the lower-band zone, sell when price recovers to the SMA as of entry. Captures partial recoveries.' },
  { key: 'meanShort', label: 'short → mean', hint: 'Short in the upper-band zone, cover when price falls to the SMA as of entry. Earns on downtrenders; bleeds in uptrends.' },
  { key: 'shortBand', label: 'short → band', hint: 'Short in the upper-band zone, cover in the lower-band zone. Captures full downswings; bleeds in uptrends.' },
];

export const STRATEGY_LABELS = STRATEGIES.reduce((map, s) => {
  map[s.key] = s.label;
  return map;
}, {});

export const DEFAULT_STRATEGY = 'band';
